import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "config/config";
import { getApiCall } from "services/apiHelper";

interface PropertyManagerDetailsState {
    PrmData: PropertyManagerDetailsResponse;
    SecondaryPrmData: PropertyManagerDetailsResponse;
    loading: boolean;
    error: string | null;
}

interface PropertyManagerDetailsResponse {
    message: string;
    result: PropertyManagerDetails[];
}

interface PropertyManagerDetails {
    role: string;
    company: string;
    emailId: string;
    firstName: string;
    lastName: string;
    propertyID: string;
    status: string;
}

const initialState: PropertyManagerDetailsState = {
    PrmData: {
        message: "",
        result: []
    },
    SecondaryPrmData: {
        message: "",
        result: []
    },
    loading: false,
    error: null
};

export const getPropertyManagerData = createAsyncThunk("getPropertyManagerData", async (payload: string, { rejectWithValue }) => {
    try {
        var url = `${baseUrl}PropertyContact/GetPropertyManagerByPropId/${payload}`;
        const response = await getApiCall<PropertyManagerDetailsResponse>(url);
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})` || error.message);
    }
})
export const getSecondaryPropertyManagerData = createAsyncThunk("getSecondaryPropertyManagerData", async (payload: string, { rejectWithValue }) => {
    try {
        var url = `${baseUrl}PropertyContact/GetSecondaryPrM_ByPropId/${payload}`;
        const response = await getApiCall<PropertyManagerDetailsResponse>(url);
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})` || error.message);
    }
})

const propertyManagerSlice = createSlice({
    name: 'propertyManagerData',
    initialState,
    reducers: {
        resetState: (state) => {
            state.PrmData = {
                message: "",
                result: []
            };
            state.SecondaryPrmData = {
                message: "",
                result: []
            };
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPropertyManagerData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getPropertyManagerData.fulfilled, (state, action: PayloadAction<PropertyManagerDetailsResponse>) => {
                state.loading = false;
                state.PrmData = action.payload;
            })
            .addCase(getPropertyManagerData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
        builder.addCase(getSecondaryPropertyManagerData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getSecondaryPropertyManagerData.fulfilled, (state, action: PayloadAction<PropertyManagerDetailsResponse>) => {
                state.loading = false;
                state.SecondaryPrmData = action.payload;
            })
            .addCase(getSecondaryPropertyManagerData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    }

});
export const { resetState : resetPropertyManagerData } = propertyManagerSlice.actions;
export default propertyManagerSlice.reducer;
